<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Url from '@/views/crs36/util/url'
  import download from "@/utils/download";
  const task = {
      1: window.$t('crs36.active.task1'),
      3: window.$t('crs36.active.task3'),
      4: window.$t('crs36.active.task4'),
      5: window.$t('crs36.active.task5'),
      6: window.$t('crs36.active.task6'),
      7: window.$t('crs36.active.task7'),
      8: window.$t('crs36.active.task8'),
      9: window.$t('crs36.active.task9'),
      10: window.$t('crs36.active.task10'),
  };
  const customerStatus = {
      A:"已激活",
      S:"冻结",
      D:"销户",
      BL:"黑名单",
      N:"未激活"
  };
  export default {
    name: 'activeuserbonus',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('crs36.bt.search') == clickName) {
            this.queryData = data;
            this.$refs.childTable.defaultGetData(data);
        }
        if("导出" == clickName || window.$t('crs36.bt.export') == clickName){
            download.exportExcel(Url.active.bonus.export, data, "奖品发放记录");
        }
      },
    },
    data () {
      return {
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('crs36.active.activeName'), field: 'activeName'},
              { title: window.$t('crs36.active.activeNo'), field: 'activeNo'},
              { title: window.$t('crs36.active.customerNo'), field: 'customerNo'},
              { title: window.$t('crs36.common.phone'), field: 'phone'},
              { title: window.$t('crs36.active.task'), field: 'task',type:2,optionList:task},
              { title: window.$t('crs36.common.status'), field: 'customerStatus',type:2,optionList:customerStatus},
              { title: window.$t('crs36.active.luckyStartTime'), type:5, field: 'startTime',format: 'yyyy-MM-dd HH:mm:ss'},
              { title: window.$t('crs36.active.luckyEndTime'), type:5, field: 'endTime',format: 'yyyy-MM-dd HH:mm:ss'},
              { title: window.$t('crs36.active.customerCreateStartTime'), type:5, field: 'customerCreateStartTime'},
              { title: window.$t('crs36.active.customerCreateEndTime'), type:5, field: 'customerCreateEndTime'},
              { title: window.$t('crs36.active.customerActivatedStartTime'), type:5, field: 'customerActivatedStartTime'},
              { title: window.$t('crs36.active.customerActivatedEndTime'), type:5, field: 'customerActivatedEndTime'},
              {click: window.$t('crs36.bt.search')},
              {click: window.$t('crs36.bt.export')},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.active.bonus.qurey, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('crs36.active.orderNo'), field: 'orderNo'},
              { title: window.$t('crs36.active.activeNo'), field: 'activeNo'},
              { title: window.$t('crs36.active.activeName'), field: 'activeName'},
              { title: window.$t('crs36.common.startTime'), field: 'startTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs36.common.endTime'), field: 'endTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs36.active.chineseName'), field: 'chineseName',render:(data,full)=>{
                      return full.firstName + "." + full.lastName;
                  }},
              { title: window.$t('crs36.active.customerNo'), field: 'customerNo'},
              { title: window.$t('crs36.common.phone'), field: 'phone'},
              { title: window.$t('crs36.active.taskName'), field: 'taskName'},
              { title: window.$t('crs36.active.amountCny'), field: 'amountCny'},
              { title: window.$t('crs36.active.amount'), field: 'amount'},
              { title: window.$t('crs36.active.platform'), field: 'platform'},
              { title: window.$t('crs36.active.customerCreateTime'), field: 'customerCreateTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs36.active.customerActivatedTime'), field: 'customerActivatedTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs36.common.status'), field: 'customerStatus',render:(data,full)=>{
                  return customerStatus[data];
                  }},
              { title: window.$t('crs36.active.luckyTime'), field: 'createDate'},
              { title: window.$t('crs36.common.createTime'), field: 'createDate'},
          ]
        }
      }
    }
  }
</script>
